import { SET_SELECTED_PAYABLE_TYPE } from "actions/selectPayableTypeActions";
import { PayableType } from "types/payable";

export interface SelectedPayableTypeState {
  selectedPayableType?: PayableType;
}

const selectedPayableAndTypeInitialState: SelectedPayableTypeState = {
  selectedPayableType: undefined,
};

const reduceSelectedPayableTypeState = (state: any, action: any): any => {
  if (action.type === SET_SELECTED_PAYABLE_TYPE) {
    return {
      ...state,
      selectedPayableType: action.payload,
    };
  } else {
    return state;
  }
};

export const selectedPayableTypeReducer = (
  state = selectedPayableAndTypeInitialState,
  action: any
): any => {
  const newState = reduceSelectedPayableTypeState(state, action);
  return newState;
};

export default selectedPayableTypeReducer;
